import React, { useState, useEffect, useRef } from 'react';
import introJs from 'intro.js';
import 'intro.js/introjs.css';

// 1. DEFINICIÓN DE ESTILOS PREMIUM
const TOUR_STYLES = `
  .welcome-modal-overlay {
    position: fixed;
    top: 0; left: 0; width: 100%; height: 100%;
    background: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(8px);
    display: flex; align-items: center; justify-content: center;
    z-index: 10000000;
    animation: tourFadeIn 0.3s ease-out;
  }
  @keyframes tourFadeIn { from { opacity: 0; } to { opacity: 1; } }

  .welcome-modal-card {
    background: white; width: 90%; max-width: 500px;
    border-radius: 20px; overflow: hidden;
    box-shadow: 0 25px 50px rgba(0,0,0,0.5);
    animation: tourSlideUp 0.5s cubic-bezier(0.19, 1, 0.22, 1);
  }
  @keyframes tourSlideUp { from { transform: translateY(60px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

  .welcome-modal-header {
    background: #003366; color: white; padding: 30px;
    text-align: center; border-bottom: 4px solid #ffc107;
  }
  .welcome-modal-header h2 { margin: 0; font-size: 1.6rem; font-weight: 700; color: white !important; }

  .welcome-modal-body { padding: 35px; color: #333; line-height: 1.6; font-size: 1.15rem; text-align: center; }
  .welcome-modal-footer { padding: 10px 35px 40px; display: flex; flex-direction: column; gap: 15px; }

  .btn-start-tour {
    background: #003366; color: white; border: none; padding: 16px;
    border-radius: 10px; font-weight: bold; cursor: pointer; font-size: 1.1rem;
    transition: all 0.2s; box-shadow: 0 4px 12px rgba(0,51,102,0.3);
  }
  .btn-start-tour:hover { background: #004a94; transform: translateY(-2px); color: white; }

  .btn-skip-tour {
    background: transparent; color: #666; border: 2px solid #eee; padding: 14px;
    border-radius: 10px; font-weight: 500; cursor: pointer; font-size: 1rem;
    transition: all 0.2s;
  }
  .btn-skip-tour:hover { background: #f8f9fa; border-color: #ddd; color: #333; }

  .custom-tooltip-style {
    max-width: 380px !important; width: 380px !important;
    border-radius: 15px !important; padding: 20px !important;
    box-shadow: 0 15px 40px rgba(0,0,0,0.2) !important;
    border: none !important; background: white !important;
  }

  .introjs-tooltip-title {
    font-family: 'Outfit', sans-serif !important;
    font-weight: 700 !important; font-size: 1.3rem !important;
    margin-bottom: 15px !important; display: block !important; color: #003366 !important;
  }

  .introjs-tooltiptext {
    font-family: 'Inter', sans-serif !important; font-size: 1rem !important;
    line-height: 1.6 !important; color: #444 !important;
  }

  .introjs-button {
    border-radius: 8px !important; padding: 10px 20px !important;
    font-weight: 600 !important; transition: all 0.2s ease !important;
    text-shadow: none !important; box-shadow: none !important;
  }

  .introjs-nextbutton { background: #003366 !important; color: white !important; border: none !important; }
  .introjs-prevbutton { background: #f0f0f0 !important; color: #666 !important; border: 1px solid #ddd !important; }
  .introjs-bullets ul li a.active { background: #003366 !important; }
  .introjs-progress { height: 6px !important; background-color: #eee !important; }
  .introjs-progressbar { background-color: #007bff !important; }
  .introjs-skipbutton {
    display: block !important; color: #999 !important; font-size: 22px !important;
    font-weight: bold !important; text-decoration: none !important;
    position: absolute !important; top: 5px !important; right: 12px !important;
    cursor: pointer !important; line-height: 1 !important;
  }
  .introjs-skipbutton:hover { color: #d9534f !important; }

  /* Asegurar que el elemento resaltado sea clicable */
  .introjs-showElement {
    z-index: 10000001 !important;
    position: relative !important;
    pointer-events: auto !important;
  }

  /* FIX PRINCIPAL: Desactivar pointer-events en TODAS las capas de intro.js que bloquean clics */
  .introjs-overlay {
    pointer-events: none !important;
  }

  .introjs-helperLayer, .introjs-tooltipReferenceLayer {
    pointer-events: none !important;
  }

  .introjs-disableInteraction {
    display: none !important;
    pointer-events: none !important;
  }

  /* FIX: Eliminar el stacking context de la vista v3 */
  body.introjs-open .margin_main {
    z-index: auto !important;
  }

  /* Asegurar que SOLO el tooltip y el elemento resaltado capturen clics */
  .introjs-tooltip {
    pointer-events: auto !important;
    z-index: 10000005 !important;
  }

  /* Tooltip desplazado a la derecha para pasos de resultados */
  .tooltip-offset-right {
    margin-left: auto !important;
    left: auto !important;
    right: 20px !important;
    position: fixed !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
  }

  .introjs-showElement,
  .introjs-showElement * {
    pointer-events: auto !important;
  }

  html, body {
    scroll-behavior: auto !important;
  }
`;

const TourAcuicultura = ({ 
  enabled: enabledProp, 
  onExit,
  title = "¡Bienvenido!",
  welcomeMessage = "¿Te gustaría realizar un breve recorrido guiado por las funciones principales?",
  localStorageKey = "ifop_tour_modular",
  steps = [],
  stepValidators = {}, // Objeto: { 'id-elemento': () => boolean }
  onBeforeStepChange,  // Función: (targetId, currentStep, tour) => Promise
  onAfterStepChange,   // Función: (targetId, currentStep, tour) => void
  tourOptions = {}     // Opciones adicionales para introJs
}) => {
  const [showWelcome, setShowWelcome] = useState(false);
  const isStartedRef = useRef(false);
  const tourRef = useRef(null);

  // A. INYECCIÓN DE ESTILOS
  useEffect(() => {
    const styleId = 'ifop-tour-styles-modular';
    if (!document.getElementById(styleId)) {
      const styleEl = document.createElement('style');
      styleEl.id = styleId;
      styleEl.innerHTML = TOUR_STYLES;
      document.head.appendChild(styleEl);
    }
  }, []);

  // B. LIMPIEZA DE RESIDUOS
  const cleanTourGarbage = () => {
    document.body.classList.remove('introjs-showElement', 'introjs-relativeElement', 'introjs-fixParent');
    const garbage = document.querySelectorAll('.introjs-overlay, .introjs-helperLayer, .introjs-tooltipReferenceLayer, .introjs-hints');
    garbage.forEach(el => el.remove());
  };

  // C. CONTROL DE PERSISTENCIA
  useEffect(() => {
    const hasSeenTour = localStorage.getItem(localStorageKey);

    if (enabledProp) {
      cleanTourGarbage();
      startTour();
    } else if (!hasSeenTour) {
      const timer = setTimeout(() => {
        setShowWelcome(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [enabledProp, localStorageKey]);

  // D. LOGICA DE INICIO
  const startTour = () => {
    if (isStartedRef.current) return;
    setShowWelcome(false);
    cleanTourGarbage();
    introJs().exit(true);

    const tour = introJs();
    tourRef.current = tour;

    tour.setOptions({
      nextLabel: 'Siguiente',
      prevLabel: 'Anterior',
      doneLabel: 'Finalizar',
      showSkipButton: true,
      skipLabel: '×',
      hidePrev: true,
      showProgress: true,
      showBullets: true,
      exitOnOverlayClick: false,
      overlayOpacity: 0.6,
      scrollToElement: true,
      tooltipClass: 'custom-tooltip-style',
      keyboardNavigation: false,
      disableInteraction: false,
      steps: steps,
      ...tourOptions
    });

    let searchValidator = null;

    tour.onbeforechange(function (targetElement) {
      tour.refresh();
      const targetId = targetElement ? targetElement.getAttribute('id') : null;
      const currentStep = tour._currentStep;

      if (searchValidator) clearInterval(searchValidator);

      // Ejecutar validaciones genéricas por intervalo
      if (targetId && stepValidators[targetId]) {
        setTimeout(() => {
          if (searchValidator) clearInterval(searchValidator);
          
          searchValidator = setInterval(() => {
            const nextBtn = document.querySelector('.introjs-nextbutton');
            const validationMsg = document.querySelector('.tour-validation-msg');
            
            const isValid = stepValidators[targetId]();

            if (nextBtn) {
              if (!isValid) {
                nextBtn.style.opacity = '0.4';
                nextBtn.style.pointerEvents = 'none';
                if (validationMsg) validationMsg.style.display = 'block';
              } else {
                nextBtn.style.opacity = '1';
                nextBtn.style.pointerEvents = 'auto';
                if (validationMsg) validationMsg.style.display = 'none';
              }
            }
          }, 500);
        }, 100);
      }

      // Hook personalizado para acciones asíncronas
      if (onBeforeStepChange) {
        return onBeforeStepChange(targetId, currentStep, tour);
      }

      return Promise.resolve();
    });

    tour.onafterchange(function (targetElement) {
      const targetId = targetElement ? targetElement.getAttribute('id') : null;
      const currentStep = tour._currentStep;

      // FIX: Forzar pointer-events:none en TODAS las capas bloqueantes de intro.js vía JS
      setTimeout(() => {
        document.querySelectorAll('.introjs-overlay, .introjs-helperLayer, .introjs-tooltipReferenceLayer, .introjs-disableInteraction').forEach(el => {
          el.style.pointerEvents = 'none';
        });
      }, 50);

      if (onAfterStepChange) {
        onAfterStepChange(targetId, currentStep, tour);
      }
    });

    tour.oncomplete(() => {
      if (searchValidator) clearInterval(searchValidator);
      isStartedRef.current = false;
      localStorage.setItem(localStorageKey, 'true');
      if (onExit) onExit();
    });

    tour.onexit(() => {
      if (searchValidator) clearInterval(searchValidator);
      isStartedRef.current = false;
      if (onExit) onExit();
    });

    tour.start();
    isStartedRef.current = true;
  };

  const handleSkipWelcome = () => {
    setShowWelcome(false);
    localStorage.setItem(localStorageKey, 'true');
    if (onExit) onExit();
  };

  if (!showWelcome && !isStartedRef.current) return null;

  return (
    <>
      {showWelcome && (
        <div className="welcome-modal-overlay">
          <div className="welcome-modal-card">
            <div className="welcome-modal-header">
              <h2>{title}</h2>
            </div>
            <div className="welcome-modal-body">
              <p>{welcomeMessage}</p>
            </div>
            <div className="welcome-modal-footer">
              <button className="btn-start-tour" onClick={startTour}>
                Iniciar Recorrido
              </button>
              <button className="btn-skip-tour" onClick={handleSkipWelcome}>
                Quizás más tarde
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TourAcuicultura;
